module.exports = __webpack_public_path__ + "static/media/communities.0d50d696.jpg";